<template>
  <section>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules">
      <div class="form-item">
        <span>Do you need us to post a copy of the policy document to the Mortgagee?</span>
        <el-form-item
          ref="post_ind"
          prop="post_ind">
          <v-radio-group
            v-model="formData.post_ind"
            :border="true"
            :list="yesNoOptions"
          />
        </el-form-item>
      </div>
      <template v-if="formData.post_ind == 1">
        <div class="form-item">
          <span>Name of Mortgagee</span>
          <el-form-item
            ref="post_nm_id"
            prop="post_nm_id">
            <v-select
              v-model="formData.post_nm_id"
              :list="isGenerali?generaliMortgagorList:mortgagorList"></v-select>
          </el-form-item>
          <div
            v-if="is_other"
            class="mg-t-15">
            <el-form-item
              ref="post_nm_other"
              class="mg-t-10"
              prop="post_nm_other">
              <v-input
                v-model="formData.post_nm_other"
                key-non-chinese/>
            </el-form-item>
          </div>

        </div>
        <div class="form-item">
          <span>Address of Mortgagee</span>
          <el-form-item
            ref="post_addr"
            prop="post_addr">
            <v-input
              v-model="formData.post_addr"
              :key-non-chinese="true"/>
          </el-form-item>
        </div>
      </template>
    </el-form>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {getGeneraliMortgagorList} from '@api/common'

export default {
  // 火险保单副本寄给承按人
  name: 'mortgageeForm',
  mixins: [MixinOptions,MixinRules],
  props:{
    form:{
      type: Object,
      default: null
    },
    mortgagorList:{
      type: Array,
      default: ()=>([])
    },
    companyId:{
      type:Number,
      default:0
    }
  },
  data () {
    return {
      generaliMortgagorList:[],
      formData:{
        post_ind: '',
        post_nm_other: '',
        post_nm_id: -1,
        post_addr: ''
      },
      rules:{
        post_ind:[
          {required: true, message: this.$t('placeholder.select'), trigger:['change', 'blur']}
        ],
        post_nm_id:[
          {required: true, message: this.$t('placeholder.select'), trigger:['change', 'blur']}
        ],
        post_nm:[
          {required: true, message: this.$t('placeholder.input'), trigger:['change', 'blur']}
        ],
        post_nm_other:[
          {required: true, message: this.$t('placeholder.input'), trigger:['change', 'blur']}
        ],
        post_addr:[
          {required: true, message: this.$t('placeholder.input'), trigger:['change', 'blur']},
          { pattern:/^[\x20-\x7e]*/g, message: this.$t('placeholder.input'),trigger: ['change', 'blur']  },
        ]
      },
      valid: false
    }
  },
  computed:{
    is_other(){
      let {post_nm_id}  = this.formData
      let data = {}
      this.mortgagorList.forEach(item=>{
        if(item.id == post_nm_id){
          data = item
          return
        }
      })
      let {is_other} = data||{}
      return is_other==1
    },
    isGenerali(){
      return  this.companyId == 23
    },
  },
  watch:{
    form:{
      immediate: true,
      handler(val){
        // console.log('post_nm_id-',post_nm_id)
        this.formData = val
      }
    },
    isGenerali:{
      immediate: true,
      handler(val){
        // console.log('post_nm_id-',post_nm_id)
        this.$nextTick(()=>{
          this.network().getGeneraliMortgagorList()
        })
      }
    }
  },
  methods: {
    submitForm (formName) {
      if(this.formData.post_ind == -1){
        // this.formData.post_ind = ''
      }
      this.$refs.form.validate((valid, rules) => {
        if(valid) {
          if(this.formData.post_ind == 0){
            this.formData.post_nm_other = ''
            this.formData.post_nm_id = -1
            this.formData.post_addr = ''
          }
          let params = JSON.parse(JSON.stringify(this.formData))
          this.$emit('getFormData', formName, params)
        }else {
          this.scrollToValidDom(rules)
        }
        this.valid = valid
      })
      return this.valid
    },
    submitFormNoVaild(formName) {
      this.$emit('getFormData', formName, this.formData)
    },
    network(){
      return{
        getGeneraliMortgagorList:async (params)=>{
          let {data} = await getGeneraliMortgagorList(params)
          let {mortgagor} = data||{}
          this.generaliMortgagorList  = mortgagor||[]
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>

</style>
